import React from 'react';
import ClaimStepClosableMessage from './ClaimStepClosableMessage';
import { ImportFileState } from './useFileImport';
import { Locale } from '../../../Translate';
import { ClaimFileType } from '../types';

type Props = {
  state: ImportFileState;
  fileType:
    | ClaimFileType.INVOICE_DOCUMENT
    | ClaimFileType.DECLARATION_OF_RECIPIENT
    | ClaimFileType.DATA_PROCESSING_CONSENT;
};

type MessageProps = {
  intent: string;
  message: {
    [ClaimFileType.INVOICE_DOCUMENT]: string;
    [ClaimFileType.DECLARATION_OF_RECIPIENT]: string;
    [ClaimFileType.DATA_PROCESSING_CONSENT]: string;
  };
};

const messagesPropsByState: Record<ImportFileState, MessageProps | null> = {
  error: {
    intent: 'danger',
    message: {
      [ClaimFileType.INVOICE_DOCUMENT]: 'CLAIMS_IMPORT_INVOICE_ERROR_MESSAGE',
      [ClaimFileType.DECLARATION_OF_RECIPIENT]: 'CLAIMS_IMPORT_DOR_ERROR_MESSAGE',
      [ClaimFileType.DATA_PROCESSING_CONSENT]: 'CLAIMS_IMPORT_CONSENT_ERROR_MESSAGE',
    },
  },
  // eslint-disable-next-line camelcase
  not_found: {
    intent: 'warning',
    message: {
      [ClaimFileType.INVOICE_DOCUMENT]: 'CLAIMS_IMPORT_INVOICE_NOT_FOUND_MESSAGE',
      [ClaimFileType.DECLARATION_OF_RECIPIENT]: 'CLAIMS_IMPORT_DOR_NOT_FOUND_MESSAGE',
      [ClaimFileType.DATA_PROCESSING_CONSENT]: 'CLAIMS_IMPORT_CONSENT_NOT_FOUND_MESSAGE',
    },
  },
  found: {
    intent: 'success',
    message: {
      [ClaimFileType.INVOICE_DOCUMENT]: 'CLAIMS_IMPORT_INVOICE_FOUND_MESSAGE',
      [ClaimFileType.DECLARATION_OF_RECIPIENT]: 'CLAIMS_IMPORT_DOR_FOUND_MESSAGE',
      [ClaimFileType.DATA_PROCESSING_CONSENT]: 'CLAIMS_IMPORT_CONSENT_FOUND_MESSAGE',
    },
  },
  searching: null,
  idle: null,
};

function FileImportMessage(props: Props) {
  const { fileType } = props;
  const { message, intent } = messagesPropsByState[props.state] || {};

  if (!message) {
    return null;
  }

  // NOTE: probably ClaimStepClosableMessage step should remember closed state so we don't show
  // the message when user goes back and forth between steps
  return (
    <ClaimStepClosableMessage intent={intent}>
      <Locale>{message[fileType]}</Locale>
    </ClaimStepClosableMessage>
  );
}

export default React.memo(FileImportMessage);
